// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import router from './router'
import store from './store'
import http from './utils/http'
import "@/directives" //自定义指令
// import * as echarts from 'echarts'
// import VueClipboard from 'vue-clipboard2'
import Vant from 'vant';
import { Lazyload } from 'vant';

import 'vant/lib/index.css';

Vue.config.productionTip = false
Vue.use(ElementUI)

// 复制剪切板
// Vue.use(VueClipboard)
Vue.use(Vant);

Vue.use(Lazyload, {
	lazyComponent: true,
});


Vue.prototype.$http = http
// Vue.prototype.$echarts = echarts

/* eslint-disable no-new */
new Vue({
	el: '#temp-app',
	store,
	router,
	components: { App },
	template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js